export default {
    state: {
        loading: false
    },
    getters: {
        LOADING: state => {
            return state.loading;
        }
    },
    mutations: {
        SET_LOADING(state, payload) {
            state.loading = payload
        }
    },
    actions: {
        SET_LOADING: ({ commit }, payload) => {
            commit('SET_LOADING', payload)
        }
    }
}